import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGithubWhiteIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 26 26",
	style: { enableBackground: "new 0 0 26 26" },
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	x: "0px",
	y: "0px",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 26,
		height: 26,
		rx: 13,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.0204 25.3655C15.7542 25.7774 14.4028 26 12.9998 26C11.5959 26 10.2437 25.7771 8.97677 25.3647C9.56202 25.4349 9.77828 25.0538 9.77828 24.7248C9.77828 24.5816 9.77584 24.329 9.77257 23.991C9.76878 23.6 9.76389 23.0947 9.76041 22.5125C6.14397 23.2987 5.38103 20.7685 5.38103 20.7685C4.79034 19.266 3.93803 18.8659 3.93803 18.8659C2.75747 18.0585 4.02741 18.0749 4.02741 18.0749C5.33147 18.1668 6.01803 19.4156 6.01803 19.4156C7.17828 21.4036 9.06084 20.8296 9.80184 20.4962C9.91966 19.6555 10.256 19.0822 10.6273 18.757C7.74053 18.4286 4.70584 17.313 4.70584 12.3282C4.70584 10.9077 5.21203 9.74675 6.04403 8.83688C5.90997 8.50767 5.46391 7.18558 6.17078 5.39438C6.17078 5.39438 7.26278 5.04473 9.74578 6.72781C10.7833 6.4391 11.8948 6.29535 13.0007 6.28948C14.1048 6.29515 15.2172 6.4391 16.2555 6.72781C18.7369 5.04473 19.8265 5.39438 19.8265 5.39438C20.5358 7.18558 20.0897 8.50767 19.9557 8.83688C20.7893 9.74675 21.2922 10.9077 21.2922 12.3282C21.2922 17.3252 18.2527 18.4254 15.3569 18.7473C15.8233 19.149 16.2393 19.9424 16.2393 21.1564C16.2393 22.3193 16.232 23.3317 16.2272 24.0026C16.2248 24.335 16.223 24.5835 16.223 24.725C16.223 25.0555 16.4341 25.4374 17.0204 25.3655Z",
		fill: "white"
	})]
});
export default SvgGithubWhiteIcon;
